import { Profiles } from '@/config'
import { Profile, ProfileListUsersFilters } from '@packages/profiles'
import { PageParam, PaginationResponse, QueryManager, ReactQuery, UseListSelector } from '@codeleap/query'
import { queryClient } from '../queryClient'
import { DefinedInitialDataInfiniteOptions, QueryKey } from '@tanstack/react-query'

async function retrieve(id: string) {
  const response = await Profiles.API.retrieve({ id })
  if (response.ok) return response.data
  return null
}

export const profilesManager = new QueryManager<Profile>({
  itemType: {} as Profile,
  name: 'profiles',
  queryClient: queryClient.client,
  limit: 20,

  listItems: async (limit, offset, filters: ProfileListUsersFilters) => {
    const response = await Profiles.API.list({
      limit,
      offset,
      ...filters,
    })
    if (response.ok) return response.data
    return null
  },

  retrieveItem: async (id: string) => {
    return retrieve(id)
  },
})

type UseProfilesProps = {
  filter?: ProfileListUsersFilters
queryOptions?: Partial<DefinedInitialDataInfiniteOptions<PaginationResponse<Profile>, Error, UseListSelector<Profile>, QueryKey, PageParam>>
}

export function useProfile({ id, queryOptions }: { id: string; queryOptions?: any}) {
  const query = ReactQuery.useQuery<Profile>({
    queryKey: ['useProfile', id],
    queryFn: () => {
      return retrieve(id)
    },
    ...queryOptions,
  })

  return query
}

export function useProfiles({ filter, queryOptions }: UseProfilesProps) {
  const list = profilesManager.useList({
    filter,
    queryOptions: {
      ...queryOptions,
      getNextPageParam(lastPage) {
        if (!lastPage?.next_token) return

        return {
          limit: 20,
          offset: lastPage.next_token as string,
        }
      },

    },
  })

  return list
}
